import { render, staticRenderFns } from "./capacity.vue?vue&type=template&id=fa3d8f5c&scoped=true&"
import script from "./capacity.vue?vue&type=script&lang=js&"
export * from "./capacity.vue?vue&type=script&lang=js&"
import style0 from "./capacity.vue?vue&type=style&index=0&id=fa3d8f5c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa3d8f5c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fa3d8f5c')) {
      api.createRecord('fa3d8f5c', component.options)
    } else {
      api.reload('fa3d8f5c', component.options)
    }
    module.hot.accept("./capacity.vue?vue&type=template&id=fa3d8f5c&scoped=true&", function () {
      api.rerender('fa3d8f5c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/settings/capacity.vue"
export default component.exports